import { Text } from '@artprov/design-system'
import { TEXTOS } from '../constants/textos.js'

/** Título y bajada comunes a las dos vistas de selección de cuenta. */
export default function EncabezadoSeleccionCuenta() {
  return (
    <>
      <div className="mb-1">
        {/* Figma: Headline/headline6_encodesans · 20px · 600 · primary_20 #003BB3 */}
        <Text variant="h6" className="text-primary-20 font-semibold">
          {TEXTOS.TITULO}
        </Text>
      </div>

      {/* Figma: Body/body2_encodesans · 14px · 500 · tertiary_0 #000000 */}
      <Text variant="body2" className="text-tertiary-0 font-medium">
        {TEXTOS.BAJADA}
      </Text>
    </>
  )
}
